'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@common/components';
import dayjs from 'dayjs';
import { HorizontalScroll, Image } from '@/components/client';
import { useAuthStore } from '@/stores/AuthStore';
import type { FestivalReview } from '../../_utils/festivalFetchers';
import { FestivalReviewMenu } from './FestivalReviewMenu';
interface FestivalReviewCardProps {
  tourId: string;
  review: FestivalReview;
}
export const FestivalReviewCard = t0 => {
  const $ = _c(36);
  const {
    tourId,
    review
  } = t0;
  const userId = useAuthStore(_temp);
  const isMyReview = review.memberOAuthId !== undefined && review.memberOAuthId === userId;
  let t1;
  if ($[0] !== review.imageUrls) {
    t1 = review.imageUrls ?? [];
    $[0] = review.imageUrls;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageUrls = t1;
  let t2;
  if ($[2] !== review.goodPoints) {
    t2 = review.goodPoints ?? [];
    $[2] = review.goodPoints;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const goodPoints = t2;
  const t3 = review.nickName ?? "\uD6C4\uAE30 \uC791\uC131\uC790";
  let t4;
  if ($[4] !== review.profileImage || $[5] !== t3) {
    t4 = <Avatar size={32} type="person" src={review.profileImage} alt={t3} />;
    $[4] = review.profileImage;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== review.nickName) {
    t5 = <span className="font-600 text-Gray-900 typo-body4">{review.nickName}</span>;
    $[7] = review.nickName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== review.createAt) {
    t6 = review.createAt ? <span className="text-Gray-550 typo-caption1">{dayjs(review.createAt).format("YYYY.MM.DD")}</span> : null;
    $[9] = review.createAt;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="flex flex-col justify-center">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isMyReview || $[15] !== review || $[16] !== tourId) {
    t8 = isMyReview && review.reviewId ? <div className="ml-auto"><FestivalReviewMenu tourId={tourId} reviewId={review.reviewId} review={review} /></div> : null;
    $[14] = isMyReview;
    $[15] = review;
    $[16] = tourId;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className="flex items-center gap-8">{t4}{t7}{t8}</div>;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== imageUrls || $[23] !== review.nickName) {
    t10 = imageUrls.length > 0 ? <HorizontalScroll className="rounded-xsmall" slideClassName="gap-2">{imageUrls.map((url, index) => <div key={url} className="flex-[0_0_auto]"><Image src={url} alt={`${review.nickName ?? "\uD6C4\uAE30"} 사진 ${index + 1}`} width={170} height={226} className="block h-[226px] w-[170px] object-cover" /></div>)}</HorizontalScroll> : null;
    $[22] = imageUrls;
    $[23] = review.nickName;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== review.contents) {
    t11 = review.contents ? <p className="m-0 whitespace-pre-line text-Gray-900 typo-body4">{review.contents}</p> : null;
    $[25] = review.contents;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t9) {
    t12 = <div className="flex flex-col gap-8">{t9}{t10}{t11}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== goodPoints) {
    t13 = goodPoints.length > 0 ? <ul className="m-0 flex list-none flex-wrap gap-4 p-0">{goodPoints.map(_temp2)}</ul> : null;
    $[31] = goodPoints;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12 || $[34] !== t13) {
    t14 = <li className="flex flex-col justify-center gap-12 border-b border-Gray-200 pb-24">{t12}{t13}</li>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
function _temp(state) {
  return state.myInfo?.id;
}
function _temp2(goodPoint) {
  return <li key={goodPoint.name ?? goodPoint.desc} className="rounded-xsmall bg-Gray-50 px-8 py-4 font-600 text-Gray-700 typo-caption1">{goodPoint.desc}</li>;
}